import type { Component } from 'solid-js'
import { Trans } from '@mbarzda/solid-i18next'
import Button, { ButtonStyle } from './Button'
import type { EventsViewType } from '../../../features/engagement/domain/models/events'
import { Icon } from '@iconify-icon/solid'

interface EventsViewToggleProps {
  selectedView: EventsViewType
  onViewChange: (view: EventsViewType) => void
}

const EventsViewToggle: Component<EventsViewToggleProps> = (props) => {
  return (
    <div class="flex items-center gap-4">
      <Button
        style={props.selectedView === 'cities' ? ButtonStyle.Primary : ButtonStyle.White}
        action={() => props.onViewChange('cities')}
      >
        <Icon icon="heroicons:map-pin" class="text-[1rem]" />
        <span class="text-sm font-medium">
          <Trans key={'ls_events_cities'} />
        </span>
      </Button>
      <Button
        style={props.selectedView === 'events' ? ButtonStyle.Primary : ButtonStyle.White}
        action={() => props.onViewChange('events')}
      >
        <Icon icon="heroicons:ticket" class="text-[1rem]" />
        <span class="text-sm font-medium">
          <Trans key={'ls_events_events'} />
        </span>
      </Button>
    </div>
  )
}

export default EventsViewToggle
